import { ThemeDefinition } from '../types';

/**
 * Dev Technology brand theme.
 *
 * Maps Dev Technology brand colors to USWDS token families:
 * - Primary: Dev Red (#d01547)
 * - Secondary: Dev Blue (#014a75)
 * - Accent-cool: Dev Purple (#4c214e)
 * - Accent-warm: Dev Green (#3a5e56)
 * - Base: Dev Gray (#575759)
 *
 * Typography uses USWDS-bundled typefaces (Public Sans, Source Code Pro)
 * to avoid external font dependencies.
 */
export const devTechnologyTheme: ThemeDefinition = {
  id: 'dev-technology',
  name: 'Dev Technology',
  colors: {
    primary: {
      lightest: '#fce4ec',
      lighter: '#f48ca8',
      light: '#e8365d',
      base: '#d01547',
      dark: '#a11038',
      darker: '#81110e',
      darkest: '#4a0a08',
    },
    secondary: {
      lightest: '#e3f0f7',
      lighter: '#7bb3d4',
      light: '#2d7aa8',
      base: '#014a75',
      dark: '#013b5e',
      darker: '#012c47',
      darkest: '#011d30',
    },
    'accent-cool': {
      lightest: '#f3e8f4',
      lighter: '#9c64a0',
      light: '#6b3570',
      base: '#4c214e',
      dark: '#3d1a3f',
      darker: '#2e1330',
      darkest: '#1f0c21',
    },
    'accent-warm': {
      lightest: '#e8f0ed',
      lighter: '#7ba897',
      light: '#4d7d6f',
      base: '#3a5e56',
      dark: '#2e4b44',
      darker: '#233833',
      darkest: '#172522',
    },
    base: {
      lightest: '#e4e4e4',
      lighter: '#c4c4c5',
      light: '#8e8e90',
      base: '#575759',
      dark: '#3d3d3f',
      darker: '#2a2a2b',
      darkest: '#171718',
    },
    error: {
      lightest: '#fce4ec',
      lighter: '#f4889a',
      light: '#e53e3e',
      base: '#b50d0d',
      dark: '#8b0a0a',
      darker: '#600707',
      darkest: '#3b0404',
    },
    warning: {
      lightest: '#fef3cd',
      lighter: '#fdd85d',
      light: '#e5a000',
      base: '#c47600',
      dark: '#936200',
      darker: '#624100',
      darkest: '#312100',
    },
    success: {
      lightest: '#e7f5e7',
      lighter: '#70c070',
      light: '#2e8540',
      base: '#1a6b2d',
      dark: '#135321',
      darker: '#0d3b17',
      darkest: '#07230d',
    },
    info: {
      lightest: '#e7f2f8',
      lighter: '#73b3d7',
      light: '#2e8bc9',
      base: '#0f6db5',
      dark: '#0b548c',
      darker: '#083c63',
      darkest: '#04243b',
    },
  },
  typography: {
    bodyFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    headingFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    monoFamily: '"Source Code Pro", "Consolas", monospace',
    bodySize: '1rem',
    lineHeight: '1.625',
  },
  focus: {
    color: '#1f7db8',
    offset: '2px',
    width: '3px',
  },
};
